import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-product-master-list',
  templateUrl: './product-master-list.component.html',
  styleUrls: ['./product-master-list.component.css']
})
export class ProductMasterListComponent implements OnInit {

  public Editor = ClassicEditor;

  data: any;
  form: any | FormGroup
  modelSubtitle = false
  product: any = []
  checked = false
  name = ""
  version = ""
  code = ""
  group = ""
  description = ""
  i: any;
  deleteId: any = "";
  recordId: any = "";
  recordName: any = "";
  cid: any

  productList: any = []
  singleProductData: any = []
  searchKey: any = ""
  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage: number = 10;
  tableSize: number = 10;
  first: number = 0;
  isLoading: any = false
  isSearch: any = false

  uomSelectedList1: any = [];
  uomDefaultList: any = this.uomSelectedList1;
  uomDropdownList: any = [];
  uomSelectedList: any = [];
  uomDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'uomMasterId',
    textField: 'uomName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
  uomData: any = [];
  isDefault: any = ""
  ProductParams: any = []
  keyValueList: any = []
  imageUrlList: any = []
  singleProduct: any
  productSpecifications: any = [
    {
      "key": "",
      "value": "",
      "keyValue": []
    }
  ]

  tags: any = [
    {
      "key": "",
    }
  ]

  warrantyInfoKeyValues: any = [
    {
      "key": "",
      "value": ""
    }
  ]

  editorConfig: any = {
    toolbar: [
      'heading', '|',
      'fontSize',
      'bold', 'italic', 'underline', '|',
      'link', 'bulletedList', 'numberedList', '|',
      'insertTable', '|',
      'blockQuote',
      'undo', 'redo'
      // Don't include 'imageUpload', 'mediaEmbed', etc.
    ],
    fontSize: {
      options: [
        9,
        11,
        13,
        'default',
        17,
        19,
        21
      ],
      supportAllValues: false
    }
  };

  relatedProductList: any = []
  similarProductList: any = []
  vendorMasters: any = []
  vendorMastersList: any = []

  vendorMastersDropdownList: any = [];
  vendorMastersSelectedList: any = [];
  vendorMastersDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'vendorMasterId',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };

  relatedProductDropdownList: any = [];
  relatedProductSelectedList: any = [];
  relatedProductDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'productMasterId',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };

  similarProductDropdownList: any = [];
  similarProductSelectedList: any = [];
  similarProductDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'productMasterId',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };

  productSaleTypeList: any = [
    {
      isChecked: false,
      type: "Click & Collect"
    },
    {
      isChecked: false,
      type: "Delivery"
    },
    {
      isChecked: false,
      type: "Instore Shopping"
    }
  ];

  currencyType: any = [
    {
      "currencyId": "6",
      "currencyName": "Euro",
      "currencySymbol": "€",
      "currencyRate": "1.17",
      "status": "0",
      "createddate": "07-09-2021",
      "createdBy": "1",
      "version": "1"
    },
    {
      "currencyId": "5",
      "currencyName": "Saudi Riyal",
      "currencySymbol": "SR",
      "currencyRate": "4",
      "status": "0",
      "createddate": "10-08-2021",
      "createdBy": "1",
      "version": "1"
    },
    {
      "currencyId": "4",
      "currencyName": "Dinar",
      "currencySymbol": "KD",
      "currencyRate": "0.42",
      "status": "0",
      "createddate": "06-08-2021",
      "createdBy": "1",
      "version": "1"
    },
    {
      "currencyId": "3",
      "currencyName": "Sterling pound",
      "currencySymbol": "£",
      "currencyRate": "1",
      "status": "0",
      "createddate": "14-07-2021",
      "createdBy": "1",
      "version": "1"
    },
    {
      "currencyId": "2",
      "currencyName": "Australian Dollar",
      "currencySymbol": "DLRe",
      "currencyRate": "50",
      "status": "0",
      "createddate": "12-07-2021",
      "createdBy": "1",
      "version": "1"
    },
    {
      "currencyId": "1",
      "currencyName": "Indian Rupee",
      "currencySymbol": "RS",
      "currencyRate": "10",
      "status": "0",
      "createddate": "08-07-2021",
      "createdBy": "1",
      "version": "1"
    },
    {
      "currencyId": "0",
      "currencyName": "GBP",
      "currencySymbol": "£",
      "currencyRate": "1",
      "status": "1",
      "createddate": "29-07-2021",
      "createdBy": "1",
      "version": "1"
    }
  ]

  taxInfoList: any = [];
  taxMasterList: any = []
  taxInfoDropdownList: any = [];
  taxInfoSelectedList: any = [];
  taxInfoDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'taxMasterId',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
  productGroupList: any = [];

  isDefaultUom = true;

  actionControls: any = {
    isAdd: false,
    isView: false,
    isDelete: false,
    isModify: false
  }

  constructor(private fb: FormBuilder, private toastr: ToastrService, private generic_service: GenericService) { }

  ngOnInit(): void {

    let href: any = window.location.href;
    let messages = href.split('/')
    let action: any = this.generic_service.checkActionControls(messages[messages.length - 1])
    this.actionControls = action

    this.cid = sessionStorage.getItem('cid')
    this.getAllProduct(this.pageNumber, this.recordsPerPage)


    this.cid = sessionStorage.getItem('cid')
    this.getallproduct()
    this.form = this.fb.group({
      name: [''],
      version: [''],
      group: [''],
      code: [''],
      description: [''],
      image: [''],
      sku: [''],
      purchaseDate: [''],
      expirationDate: [''],
      warranty: [''],
    })
    this.getAllUomMaster()
    this.getParamByType()
    this.getAllTaxMaster()
    this.getallVendor()
    this.getAllProductMasterGroup()
  }

  isActive(isActive: any) {
    if (isActive == true) {
      return "Active"
    } else {
      return "Not Active"
    }
  }


  refreshSearch() {
    this.searchKey = ""
    this.pageNumber = 0
    this.first = 0
    this.getAllProduct(this.pageNumber, this.recordsPerPage)
  }

  refreshAll() {
    this.searchKey = ""
    this.pageNumber = 0
    this.first = 0
    this.getAllProduct(this.pageNumber, this.recordsPerPage)
  }

  getProductByWildSearch(pageNumber: any, recordsPerPage: any) {
    if (this.searchKey != "") {
      this.isLoading = true

      this.isSearch = true

      this.generic_service.getProductByWildSearch(this.searchKey, pageNumber, recordsPerPage).subscribe(
        (response: any) => {
          console.log(response);
          this.productList = response.response.productMasterList;
          this.totalRecords = response.response.totalRecords;
          this.isLoading = false

        },
        (err: any) => {
          console.log(err)
        }
      )
    } else {
      this.getAllProduct(this.pageNumber, this.recordsPerPage)
    }
  }


  getAllProduct(pageNumber: any, recordsPerPage: any) {
    this.isLoading = true

    this.generic_service.getProduct(pageNumber, recordsPerPage).subscribe(
      (response: any) => {
        console.log(response)
        this.productList = response.response.productMasterList;
        this.totalRecords = response.response.totalRecords;
        this.isLoading = false

      }
    )
  }

  onTableDataChange(event: any) {
    this.pageNumber = event.page;

    console.log(event)

    if (this.searchKey == "") {
      this.getAllProduct(this.pageNumber, this.recordsPerPage)
    } else {
      this.getProductByWildSearch(this.pageNumber, this.recordsPerPage)
    }
  }

  getProductById(id: any) {
    this.generic_service.getProductById(id).subscribe(
      (response: any) => {
        console.log(response)
        this.singleProductData = []
        this.singleProductData.push(response.response)
      },
      (error) => {
        console.log(error)
      }
    )
  }


  getProductById1(id: any) {
    this.generic_service.getProductById(id).subscribe(
      (response: any) => {
        console.log(response)
        this.singleProductData = []
        this.singleProductData.push(response.response)

        this.singleProduct = response.response
        this.form.patchValue({
          name: response.response.name,
          version: response.response.version,
          group: response.response.group,
          description: response.response.description,
          code: response.response.code,
          image: response.response.imageUrl,
          purchaseDate: response.response.warrantyInfo ? formatDate(response.response.warrantyInfo.purchaseDate, 'yyyy-MM-dd', 'en-US') : null,
          expirationDate: response.response.warrantyInfo ? formatDate(response.response.warrantyInfo.expirationDate, 'yyyy-MM-dd', 'en-US') : null,
          warranty: response.response.warranty,
          sku: response.response.sku
        })

        this.warrantyInfoKeyValues = response.response.warrantyInfo ? response.response.warrantyInfo.keyValues : [];



        this.imageUrlList = response.response.imageUrlList
        this.uomSelectedList1 = response.response.supportedUOM;
        for (let i = 0; i < response.response.supportedUOM.length; i++) {
          if (response.response.supportedUOM[i].isDefault) {
            this.isDefault = String(response.response.supportedUOM[i].uomId)
          }
          this.uomSelectedList.push(
            {
              "uomMasterId": response.response.supportedUOM[i].uomId,
              "uomName": response.response.supportedUOM[i].uomName
            }
          )
        }

        if (response.response.productSpecifications.length != 0) {
          this.productSpecifications = []
        }

        for (let i = 0; i < response.response.productSpecifications.length; i++) {
          this.productSpecifications.push(
            {
              "key": response.response.productSpecifications[i].key,
              "value": response.response.productSpecifications[i].value,
              "keyValue": []
            }
          )
        }

        this.vendorMasters = response.response.vendorMasters
        for (let i = 0; i < response.response.vendorMasters.length; i++) {
          this.vendorMastersSelectedList.push(
            {
              "vendorMasterId": response.response.vendorMasters[i].vendorMasterId,
              "name": response.response.vendorMasters[i].name
            }
          )
        }

        this.relatedProductList = response.response.relatedProductList
        for (let i = 0; i < response.response.relatedProductList.length; i++) {
          this.relatedProductSelectedList.push(
            {
              "productMasterId": response.response.relatedProductList[i].productMasterId,
              "name": response.response.relatedProductList[i].name
            }
          )
        }
        this.similarProductList = response.response.similarProductList
        for (let i = 0; i < response.response.similarProductList.length; i++) {
          this.relatedProductSelectedList.push(
            {
              "productMasterId": response.response.similarProductList[i].productMasterId,
              "name": response.response.similarProductList[i].name
            }
          )
        }

        this.taxInfoList = response.response.taxInfoList
        for (let i = 0; i < response.response.taxInfoList.length; i++) {
          this.taxInfoSelectedList.push(
            {
              "taxMasterId": response.response.taxInfoList[i].taxMasterId,
              "name": response.response.taxInfoList[i].name
            }
          )
        }

        for (let i = 0; i < response.response.productSaleType.length; i++) {
          for (let j = 0; j < this.productSaleTypeList.length; j++) {
            if (this.productSaleTypeList[j].type == response.response.productSaleType[i]) {
              this.productSaleTypeList[j].isChecked = true
            }
          }
        }

        if (response.response.tags.length != 0) {
          this.tags = []
        }
        for (let i = 0; i < response.response.tags.length; i++) {
          this.tags.push(
            {
              "key": response.response.tags[i]
            }
          )
        }
      },
      (error) => {
        console.log(error)
      }
    )
  }

  checkPage() {
    // let pageNumber = 0
    // if(this.pageNumber == 0){
    //   pageNumber = this.pageNumber
    // }else{
    //   pageNumber = this.pageNumber-1
    // }
  }

  del(id: any) {
    this.deleteId = id
  }



  addProductSpecifications() {
    this.productSpecifications.push(
      {
        "key": "",
        "value": "",
        "keyValue": []
      }
    )
  }

  removeProductSpecifications(index: any) {
    this.productSpecifications.splice(index, 1)
  }

  addTags() {
    this.tags.push(
      {
        "key": ""
      }
    )
  }

  removeTags(index: any) {
    this.tags.splice(index, 1)
  }


  addWarrantyInfoKeyValues() {
    this.warrantyInfoKeyValues.push(
      {
        "key": "",
        "value": ""
      }
    )
  }

  toggleWarrantyInfoKeyValues() {
    this.warrantyInfoKeyValues.push(
      {
        "key": "",
        "value": ""
      }
    )
  }

  removeWarrantyInfoKeyValues(index: any) {
    this.warrantyInfoKeyValues.splice(index, 1)
  }

  getAllTaxMaster() {
    this.generic_service.getAllTaxMaster().subscribe(
      (response: any) => {
        this.taxInfoDropdownList = response.response
        this.taxMasterList = response.response
      }
    )
  }

  onTaxInfoSelect(item: any) {
    for (let i = 0; i < this.taxMasterList.length; i++) {
      if (this.taxMasterList[i].taxMasterId == item.taxMasterId) {
        this.taxInfoList.push(
          {
            "id": this.taxMasterList[i].id,
            "taxMasterId": this.taxMasterList[i].taxMasterId,
            "name": this.taxMasterList[i].name,
            "percentage": this.taxMasterList[i].percentage,
            "amount": this.taxMasterList[i].amount,
            "cid": this.taxMasterList[i].cid,
          }
        )
      }
    }
  }

  onDeSelectTaxMaster(item: any) {
    let taxIndex = 0;
    for (let i = 0; i < this.taxInfoList.length; i++) {
      if (this.taxInfoList[i].taxMasterId == item.taxMasterId) {
        taxIndex = i;
      }
    }
    this.taxInfoList.splice(taxIndex, 1)
  }

  getAllProductMasterGroup() {
    this.generic_service.getAllProductMasterGroup().subscribe(
      (res: any) => {
        console.log(res)
        this.productGroupList = res.response
      },
      (err: any) => {
        console.log(err)
      }
    )
  }

  getallVendor() {
    this.generic_service.getAllVendor().subscribe(
      (response: any) => {
        this.vendorMastersList = response.response;
        this.vendorMastersDropdownList = response.response
      }
    )
  }

  getallproduct() {
    this.generic_service.getAllProducts().subscribe(
      (response: any) => {
        this.relatedProductDropdownList = response.response
        this.similarProductDropdownList = response.response
        this.product = response.response;
      }
    )
  }

  onRelatedProductSelect(item: any) {
    for (let i = 0; i < this.product.length; i++) {
      if (this.product[i].productMasterId == item.productMasterId) {
        this.relatedProductList.push(
          {
            "id": this.product[i].id,
            "productMasterId": this.product[i].productMasterId,
            "name": this.product[i].name,
            "imageUrl": this.product[i].imageUrl,
            "supportedUOM": this.product[i].supportedUOM
          }
        )
      }
    }
  }

  onFilterChange(item: any) {
  }

  onDropDownClose(item: any) {
  }

  onDeSelect(item: any) {
    let productIndex = 0;
    for (let i = 0; i < this.relatedProductList.length; i++) {
      if (this.relatedProductList[i].productMasterId == item.productMasterId) {
        productIndex = i;
      }
    }
    this.relatedProductList.splice(productIndex, 1)
  }

  onDeSelectAll(items: any) {
  }

  onRelatedProductSelectAll(items: any) {
  }

  // refresh(){
  //   console.log('ok')
  //   this.uomDefaultList = this.uomSelectedList1;
  //   console.log(this.uomDefaultList)

  // }

  onItemSelect(item: any) {
    this.uomSelectedList1.push(
      {
        "uomId": item.uomMasterId,
        "uomName": item.uomName,
        "price": 0,
        "discountedPrice": 0,
        "quantity": 0,
        "cid": 0,
        "isDefault": false,
        "distributorPrice": 0,
        "dealerPrice": 0,
        "color": "",
        "currencyType": "",
        "currencySymbol": "",
        "minOrderQuantity": 0,
        "maxOrderQuantity": 0
      }
    )
  }

  onItemDeSelect(item: any) {
    const index = this.uomSelectedList1.findIndex(
      (u: any) => u.uomId === item.uomMasterId
    );
    if (index !== -1) {
      this.uomSelectedList1.splice(index, 1);
    }
  }


  onSelectAll(items: any) {
  }

  getAllUomMaster() {
    this.generic_service.getAllUomMaster().subscribe(
      (res: any) => {
        console.log(res);
        this.uomDropdownList = res.response
        this.uomData = res.response

        this.uomSelectedList1.push(
          {
            "uomId": res.response[0].uomMasterId,
            "uomName": res.response[0].uomName,
            "price": 0,
            "discountedPrice": 0,
            "quantity": 0,
            "cid": res.response[0].cid,
            "color": "",
            "isDefault": true,
            "currencyType": "",
            "currencySymbol": "",
            "minOrderQuantity": 0,
            "maxOrderQuantity": 0
          })
      },
      (err: any) => {
        console.log(err)
      }
    )
  }

  currencyChanged(currency: any, index: any) {
    for (let i = 0; i < this.currencyType.length; i++) {

    }
  }

  addProduct() {
    let tags: any = []
    for (let i = 0; i < this.tags.length; i++) {
      tags.push(this.tags[i].key)
    }

    let supportedUOM: any = []

    for (var i = 0; i < this.uomSelectedList1.length; i++) {
      for (var j = 0; j < this.uomData.length; j++) {
        if (this.uomData[j].uomMasterId == Number(this.uomSelectedList1[i].uomId)) {
          this.uomSelectedList1[i].uomName = this.uomData[j].uomName
        }
      }
    }

    for (let j = 0; j < this.uomSelectedList1.length; j++) {
      if (this.uomSelectedList1[j].uomId == Number(this.isDefault)) {
        this.uomSelectedList1[j].isDefault = true;
      }
    }

    let keyValueList: any = []
    for (let i = 0; i < this.keyValueList.length; i++) {
      keyValueList.push(
        {
          "key": this.keyValueList[i].key,
          "value": this.keyValueList[i].value
        }
      )
    }

    let productSaleType: any = []
    for (let i = 0; i < this.productSaleTypeList.length; i++) {
      if (this.productSaleTypeList[i].isChecked == true) {
        productSaleType.push(this.productSaleTypeList[i].type)
      }
    }

    let productSpecifications: any = []
    for (let i = 0; i < this.productSpecifications.length; i++) {
      if (this.productSpecifications[i].key != '') {
        productSpecifications.push(
          {
            "key": this.productSpecifications[i].key,
            "value": this.productSpecifications[i].value,
            "keyValue": []
          }
        )
      }

    }

    let body = {
      "createdDate": new Date().getTime(),
      "version": String(this.form.get('version').value),
      "isActive": true,
      "description": String(this.form.get('description').value),
      "code": String(this.form.get('code').value),
      "name": String(this.form.get('name').value),
      "group": String(this.form.get('group').value),
      "supportedUOM": this.uomSelectedList1,
      "keyValueList": keyValueList,
      "status": "",
      "imageUrl": String(this.form.get('image').value),
      "sku": String(this.form.get('sku').value),
      "cid": this.cid ? Number(this.cid) : 0,
      "productSpecifications": productSpecifications,
      "imageUrlList": this.imageUrlList,
      "relatedProductList": this.relatedProductList,
      "similarProductList": this.similarProductList,
      "vendorMasters": this.vendorMasters,
      "productSaleType": productSaleType,
      "taxInfoList": this.taxInfoList,
      "productRating": 0,
      "tags": tags,
      "warranty": this.form.get('warranty').value ? true : false,
      "warrantyInfo": {
        "keyValues": this.warrantyInfoKeyValues,
        "purchaseDate": 0,
        "expirationDate": 0
      },
    }
    this.generic_service.addProduct(body).subscribe(
      (response: any) => {
        this.getallproduct()
        this.toastr.success(response.message);
        this.cancelModel()
        this.uomSelectedList1 = []
        this.imageUrlList = []
        this.relatedProductSelectedList = []
        this.similarProductSelectedList = []
        this.vendorMastersSelectedList = []
        this.taxInfoSelectedList = []
        this.productSpecifications = [
          {
            "key": "",
            "value": "",
            "keyValue": []
          }
        ]
        this.addUOM()
        this.form.reset()
        for (let i = 0; i < this.productSaleTypeList.length; i++) {
          this.productSaleTypeList[i].isChecked = false
        }
        this.form.patchValue({
          name: "",
          image: "",
        })

        this.tags = [
          {
            "key": "",
          }
        ]
        this.warrantyInfoKeyValues = [
          {
            "key": "",
            "value": ""
          }
        ]

      },
      (err: any) => {
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      },
    )
  }

  resetForm() {
    this.uomSelectedList1 = []
    this.imageUrlList = []
    this.relatedProductSelectedList = []
    this.similarProductSelectedList = []
    this.vendorMastersSelectedList = []
    this.taxInfoSelectedList = []
    this.productSpecifications = [
      {
        "key": "",
        "value": "",
        "keyValue": []
      }
    ]
    this.addUOM()
    this.form.reset()
    for (let i = 0; i < this.productSaleTypeList.length; i++) {
      this.productSaleTypeList[i].isChecked = false
    }
    this.form.patchValue({
      name: "",
      image: "",
    })

    this.tags = [
      {
        "key": "",
      }
    ]
    this.warrantyInfoKeyValues = [
      {
        "key": "",
        "value": ""
      }
    ]
  }

  cancelModel() {
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
    document.getElementById("closeModalButton3")?.click()
    document.getElementById("closeModalButton4")?.click()
  }

  open() {
    this.modelSubtitle = true;
  }

  close() {
    this.modelSubtitle = false;
    this.name = ""
    this.version = ""
    this.code = ""
    this.description = ""
  }

  deleleProduct() {
    this.generic_service.delProduct(this.deleteId).subscribe(
      (res: any) => {
        this.toastr.success(res.message);
        this.getallproduct();
        this.cancelModel();
      }, err => {
        this.toastr.error(err.errors[0].description);
      }
    )
  }

  getParamByType() {
    this.generic_service.getParamByType('PRODUCTPARAMS').subscribe(
      (response: any) => {
        this.ProductParams = response.response;
        for (let i = 0; i < this.ProductParams.length; i++) {
          this.keyValueList.push(
            {
              "key": this.ProductParams[i].name,
              "value": "",
              "possibleValue": this.ProductParams[i].possibleValue
            }
          )
        }
      }
    )
  }

  onChange(event: any) {
    this.onUpload(event.target.files[0])
  }

  onUpload(file: any) {
    this.generic_service.uploadImage(file).subscribe(
      (event: any) => {
        this.form.patchValue(
          {
            image: event.response
          }
        );
      }
    );
  }

  imageRemove() {
    this.form.patchValue(
      {
        image: ""
      }
    )
  }

  imageButtonClick() {
    document.getElementById("imageInput")?.click()
  }

  imageListButtonClick() {
    document.getElementById("imageListInput")?.click()
  }

  onListChange(event: any) {
    this.onListUpload(event.target.files[0])
  }

  onListUpload(file: any) {
    this.generic_service.uploadImage(file).subscribe((event: any) => {
      this.imageUrlList.push(event.response);
    });
  }

  imageListRemove(index: any) {
    this.imageUrlList.splice(index, 1)
  }

  removeRelatedProductList(index: any, productMasterId: any) {
    this.relatedProductList.splice(index, 1)
    let productIndex = 0;
    for (let i = 0; i < this.relatedProductSelectedList.length; i++) {
      if (this.relatedProductSelectedList[i].productMasterId == productMasterId) {
        productIndex = i;
      }
    }
    this.relatedProductSelectedList.splice(productIndex, 1)
  }

  onSimilarProductSelect(item: any) {
    for (let i = 0; i < this.product.length; i++) {
      if (this.product[i].productMasterId == item.productMasterId) {
        this.similarProductList.push(
          {
            "id": this.product[i].id,
            "productMasterId": this.product[i].productMasterId,
            "name": this.product[i].name,
            "imageUrl": this.product[i].imageUrl,
            "supportedUOM": this.product[i].supportedUOM
          }
        )
      }
    }
  }

  onDeSelectSimilar(item: any) {
    let productIndex = 0;
    for (let i = 0; i < this.similarProductList.length; i++) {
      if (this.similarProductList[i].productMasterId == item.productMasterId) {
        productIndex = i;
      }
    }
    this.similarProductList.splice(productIndex, 1)
  }

  vendorSelect(item: any) {
    for (let i = 0; i < this.vendorMastersList.length; i++) {
      if (this.vendorMastersList[i].vendorMasterId == item.vendorMasterId) {
        this.vendorMasters.push(
          {
            "version": this.vendorMastersList[i].version,
            "isActive": this.vendorMastersList[i].isActive,
            "description": this.vendorMastersList[i].description,
            "vendorMasterId": this.vendorMastersList[i].vendorMasterId,
            "code": this.vendorMastersList[i].code,
            "name": this.vendorMastersList[i].name,
            "status": this.vendorMastersList[i].status,
            "cid": this.vendorMastersList[i].cid
          }
        )
      }
    }
  }

  onDeSelectVendor(item: any) {
    let vendorIndex = 0;
    for (let i = 0; i < this.vendorMasters.length; i++) {
      if (this.vendorMasters[i].vendorMasterId == item.vendorMasterId) {
        vendorIndex = i;
      }
    }
    this.vendorMasters.splice(vendorIndex, 1)
  }

  addUOM() {
    this.uomSelectedList1.push(
      {
        "uomId": this.uomDropdownList[0].uomMasterId,
        "uomName": this.uomDropdownList[0].uomName,
        "price": 0,
        "discountedPrice": 0,
        "quantity": 0,
        "cid": this.uomDropdownList[0].cid,
        "color": "",
        "isDefault": true,
        "currencyType": "",
        "currencySymbol": "",
        "minOrderQuantity": 0,
        "maxOrderQuantity": 0
      }
    )
  }

  removeUOM(index: any) {
    this.uomSelectedList1.splice(index, 1)
  }

  uomChange(event: any, index: any) {
    console.log('ok')
    console.log(event.target.value)
    this.isDefaultUom = false;
    console.log(this.uomDefaultList)
    console.log(this.uomSelectedList1)
    for (let i = 0; i < this.uomData.length; i++) {
      if (this.uomData[i].uomMasterId == event.target.value || String(this.uomData[i].uomMasterId) == event.target.value) {
        this.uomSelectedList1[index].uomName = this.uomData[i].uomName
      }
    }
    this.uomDefaultList = this.uomSelectedList1;
    this.isDefaultUom = true;


  }


  updateProduct() {
    let tags: any = []
    for (let i = 0; i < this.tags.length; i++) {
      tags.push(this.tags[i].key)
    }

    for (let j = 0; j < this.uomSelectedList1.length; j++) {
      if (this.uomSelectedList1[j].uomId == Number(this.isDefault)) {
        this.uomSelectedList1[j].isDefault = true;
      }
    }

    let keyValueList: any = []
    for (let i = 0; i < this.keyValueList.length; i++) {
      keyValueList.push(
        {
          "key": this.keyValueList[i].key,
          "value": this.keyValueList[i].value
        }
      )
    }

    let productSaleType: any = []
    for (let i = 0; i < this.productSaleTypeList.length; i++) {
      if (this.productSaleTypeList[i].isChecked == true) {
        productSaleType.push(this.productSaleTypeList[i].type)
      }
    }

    let body = {
      "createdBy": 0,
      "createdDate": 0,
      "modifiedBy": 0,
      "modifiedDate": 0,
      "version": String(this.form.get('version').value),
      "isActive": true,
      "description": String(this.form.get('description').value),
      "code": String(this.form.get('code').value),
      "name": String(this.form.get('name').value),
      "group": String(this.form.get('group').value),
      "supportedUOM": this.uomSelectedList1,
      "keyValueList": keyValueList,
      "status": "",
      "imageUrl": String(this.form.get('image').value),
      "sku": String(this.form.get('sku').value),
      "cid": this.cid ? Number(this.cid) : 0,
      "productSpecifications": this.productSpecifications,
      "imageUrlList": this.imageUrlList,
      "relatedProductList": this.relatedProductList,
      "similarProductList": this.similarProductList,
      "vendorMasters": this.vendorMasters,
      "productSaleType": productSaleType,
      "taxInfoList": this.taxInfoList,
      "productRating": 0,
      "tags": tags,
      "warranty": this.form.get('warranty').value ? true : false,
      "warrantyInfo": {
        "keyValues": this.warrantyInfoKeyValues,
        "purchaseDate": this.form.get('purchaseDate').value ? new Date(this.form.get('purchaseDate').value).getTime() : 0,
        "expirationDate": this.form.get('expirationDate').value ? new Date(this.form.get('expirationDate').value).getTime() : 0
      },
      "productMasterId": this.singleProduct.productMasterId,
      "objectTemplateId": this.singleProduct.objectTemplateId
    }
    this.generic_service.updateProduct(body).subscribe(
      (response: any) => {
        this.getAllProduct(this.pageNumber, this.recordsPerPage)
        this.toastr.success(response.message);
        this.cancelModel()
      },
      (err: any) => {
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      },
    )
  }


  productMasterBulkUploadButtonClick() {
    document.getElementById("bulkAdd")?.click()
  }

  productMasterBulkUpload(event: any) {
    console.log(event)

    const file = event.target.files[0];

    if (file) {
      const fileName = file.name;
      const fileType = file.type;

      // Check if file is an Excel file by its MIME type
      if (fileType === 'application/vnd.ms-excel' || fileType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        console.log('Valid Excel file selected:', fileName);
        // Process the file here
      } else {
        alert('Please select a valid Excel file.');
      }
    }
  }

  selectDelete(id: any, record: any) {
    this.deleteId = id;
    this.recordId = record.productMasterId;
    this.recordName = record.name;
  }

  closeModal() {
    this.recordId = "";
    this.recordName = "";
  }

}